import styled from 'styled-components';
import ArrowDropDownIcon from '../../../../Icons/ArrowDropDownIcon';

export const FilterToggleContainerOuterWrap = styled.div(
  props => `
    padding-top:${props.theme.spacing.large};
  `,
);

export const FilterToggleInnerWrap = styled.div(
  props => `
    border: .1rem solid ${props.theme.colors.goGreen.light};
    border-radius:${props.theme.misc.borderRadius.xlarge};
    padding:${props.theme.spacing.custom(5)};
    cursor: pointer;
  `,
);

export const FilterToggleHeaderWrap = styled.div(
  props => `
    display:flex;
    align-items: center;
    background: ${props.fillType};
    padding: 0 ${props.theme.spacing.custom(7)}  ;
    margin-bottom: ${props.theme.spacing.base};
    height:2.8rem;
    border-radius:${props.theme.misc.borderRadius.xlarge};
    width: fit-content;
  `,
);

export const FilterToggleHeaderItem = styled.span(
  props => `
    font-weight:bold;
    padding-left:${props.theme.spacing.small};
  `,
);
export const FilterToggleSwitchWrapper = styled.div(
  props => `
    display:flex;
    justify-content: space-between;
    align-items: flex-end;
  
  `,
);

export const FilterToggleItemDescription = styled.p(
  props => `
    color: ${props.theme.colors.downriver.dark};
    max-width: 17rem;
  `,
);

export const FilterToggleSwitchLabel = styled.label(
  props => `
    position: relative;
    display: flex;
    width: 3.6rem;
    height: 2rem;
    >input{
      opacity: 0;
      width: 0;
      height: 0;
    }
  `,
);

export const FilterToggleCircularSwitch = styled.span(
  props => `
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props.theme.colors.goBrandBlue.light};
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: ${props.theme.misc.borderRadius.custom(34)};
  
    &::before{
      position: absolute;
      content: "";
      height: 2rem;
      width: 2rem;
      left: 0;
      bottom: 0;
      background-color: ${props.theme.colors.ash.dark};
      -webkit-transition: .4s;
      transition: .4s;
      border-radius: 50%;
    }
  `,
);

export const FilterToggleSwitchInput = styled.input(
  props => `
    &:checked + ${FilterToggleCircularSwitch}{
      background-color: ${props.theme.colors.goBrandBlue.base};
    }
    &:checked + ${FilterToggleCircularSwitch}:before{
      transform: translateX(16px);
    }
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const CheckboxListWrapperDiv = styled.div(
  props => `
  padding: ${
    props.isSingleFilter ? props.theme.spacing.small : props.theme.spacing.xlarge
  } ${props.theme.spacing.custom(8)} ${
    props.isSingleFilter ? props.theme.spacing.xlarge : props.theme.spacing.xlarge
  } ${props.theme.spacing.custom(8)};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
`,
);

export const ShowAllText = styled.div(
  props => `
  cursor: pointer;
  color: ${props.theme.colors.goBrandBlue.base};
  padding-top: ${props.theme.spacing.large};
`,
);

export const ResetTextWrapper = styled.span`
  font-size: ${props => props.theme.font.custom(12)};
  cursor: pointer;
  color: ${props =>
    props.isactive === 'true'
      ? props.theme.colors.goBrandBlue.base
      : props.theme.colors.downriver.medium};
`;

export const StyledH5 = styled.h5(
  props => `
  font-size: ${props.theme.font.custom(14)};
  color:${props.theme.colors.downriver.base};
  font-weight:bold;

`,
);

export const ArrowDropDownCollapsedIcon = styled(ArrowDropDownIcon)`
  transform: rotate(-90deg);
`;
